<template>
    <div class="modal fade" id="updatePersonModal" role="dialog" aria-labelledby="updatePersonModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="text-center" v-if="resultString">
                        <h1>{{resultString}}</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        components: {
           
        },
        props: {
            value: {
                type: String,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                resultString: '',
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose');
                this.resultString = '';
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            //add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            //remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.resultString = this.value;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
